export function isUpgradeItem(item: any): boolean {
  return (
    !!item?.productId?.category &&
    String(item.productId.category).toLowerCase() === 'upgrade'
  );
}

export function isCrossgradeProduct(product: any): boolean {
  return String(product?.name ?? '')
    .toLowerCase()
    .includes('crossgrade');
}
